(() => {
  if (window.lucasFontanaProductReady) return;
  window.lucasFontanaProductReady = true;
  const requests = new Map();
  const previewOpeners = new WeakMap();

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-option-link]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const section = link.closest('[data-product-section]');
    if (!section) return;
    if (section.dataset.cartPending === 'true') { event.preventDefault(); return; }
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || destination.pathname !== location.pathname) return;
    event.preventDefault();
    const sectionId = section.dataset.sectionId;
    requests.get(sectionId)?.abort();
    const controller = new AbortController();
    requests.set(sectionId, controller);
    const status = section.querySelector('[data-product-status]');
    if (status) status.textContent = status.dataset.loadingText;
    section.setAttribute('aria-busy', 'true');
    section.querySelectorAll('[data-product-submit]').forEach((button) => { button.disabled = true; });
    const requestUrl = new URL(destination);
    requestUrl.searchParams.set('section_id', sectionId);
    try {
      const response = await fetch(requestUrl, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Product response unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = html.getElementById(section.id);
      if (!replacement) throw new Error('Product section unavailable');
      if (controller.signal.aborted) return;
      const quantity = section.querySelector('[name="quantity"]')?.value;
      section.querySelectorAll('[data-pdf-dialog][open]').forEach((dialog) => dialog.close());
      section.replaceWith(replacement);
      document.dispatchEvent(new CustomEvent('lf:section:updated', { detail: { root: replacement } }));
      const quantityInput = replacement.querySelector('input[type="number"][name="quantity"]');
      if (quantityInput && quantity) {
        const previousQuantity = Number(quantity);
        const minimum = Number(quantityInput.min) || 1;
        const maximum = Number(quantityInput.max) || Infinity;
        const increment = Number(quantityInput.step) || 1;
        if (previousQuantity >= minimum && previousQuantity <= maximum && (previousQuantity - minimum) % increment === 0) quantityInput.value = quantity;
      }
      history.replaceState(history.state, '', destination);
      replacement.querySelector(`[data-option-id="${CSS.escape(link.dataset.optionId)}"]`)?.focus({ preventScroll: true });
    } catch (error) {
      if (error.name !== 'AbortError') location.assign(destination);
    } finally {
      if (requests.get(sectionId) === controller) requests.delete(sectionId);
    }
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-video-embed]');
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const frame = trigger.closest('[data-video-frame]');
    if (!frame) return;
    let source;
    try { source = new URL(trigger.dataset.videoEmbed); } catch { return; }
    if (!['https://www.youtube-nocookie.com', 'https://player.vimeo.com'].includes(source.origin)) return;
    event.preventDefault();
    const iframe = document.createElement('iframe');
    iframe.src = source.href;
    iframe.title = trigger.dataset.videoTitle;
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;
    iframe.tabIndex = 0;
    frame.replaceChildren(iframe);
    iframe.focus();
  });
  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-pdf-close]');
    if (closeButton) {
      closeButton.closest('[data-pdf-dialog]')?.close();
      return;
    }
    if (event.target.matches('[data-pdf-dialog]')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
      return;
    }
    const trigger = event.target.closest('[data-pdf-preview]');
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const dialog = document.getElementById(trigger.dataset.pdfPreview);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const container = dialog.querySelector('[data-pdf-container]');
    if (!container) return;
    let source;
    try { source = new URL(trigger.href, location.href); } catch { return; }
    if (!['https:', 'http:'].includes(source.protocol)) return;
    event.preventDefault();
    const iframe = document.createElement('iframe');
    iframe.title = dialog.dataset.pdfFrameTitle;
    iframe.referrerPolicy = 'no-referrer';
    iframe.src = source.href;
    container.replaceChildren(iframe);
    previewOpeners.set(dialog, trigger);
    dialog.showModal();
    document.documentElement.classList.add('lf-preview-open');
  });

  document.addEventListener('close', (event) => {
    if (!event.target.matches('[data-pdf-dialog]')) return;
    event.target.querySelector('[data-pdf-container]')?.replaceChildren();
    if (!document.querySelector('[data-pdf-dialog][open]')) document.documentElement.classList.remove('lf-preview-open');
    previewOpeners.get(event.target)?.focus({ preventScroll: true });
  }, true);

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-pdf-dialog][open]').forEach((dialog) => dialog.close());
    requests.get(event.detail.sectionId)?.abort();
  });
})();
